import React, { useEffect, useState } from 'react';
import { Button, Link, Paper, Stack, Typography } from '@mui/material';
import {
    OPEN_COOKIE_SETTINGS_EVENT,
    acceptAnalytics,
    getCookieConsent,
    loadAnalytics,
    rejectAnalytics,
} from '../../utils/analytics';
import './CookieBanner.scss';

// Baner zgody na cookies analityczne. Google Analytics ładuje się dopiero po kliknięciu „Akceptuję”.
export default function CookieBanner() {
    const [open, setOpen] = useState(() => getCookieConsent() === null);

    useEffect(() => {
        if (getCookieConsent() === 'accepted') {
            loadAnalytics();
        }

        const reopen = () => setOpen(true);
        window.addEventListener(OPEN_COOKIE_SETTINGS_EVENT, reopen);
        return () => window.removeEventListener(OPEN_COOKIE_SETTINGS_EVENT, reopen);
    }, []);

    if (!open) {
        return null;
    }

    const handleAccept = () => {
        acceptAnalytics();
        setOpen(false);
    };

    const handleReject = () => {
        rejectAnalytics();
        setOpen(false);
    };

    return (
        <Paper className='cookieBanner' role='dialog' aria-live='polite' aria-label='Ustawienia plików cookies' elevation={8}>
            <Stack direction={{ xs: 'column', md: 'row' }} spacing={2} alignItems={{ xs: 'stretch', md: 'center' }}>
                <Typography variant='body2' className='cookieBanner_text'>
                    Używamy danych zapisywanych w przeglądarce, które są niezbędne do działania serwisu (np. utrzymania
                    logowania). Za Twoją zgodą korzystamy też z analitycznych plików cookies Google Analytics, żeby
                    sprawdzać, jak używasz strony, i ją ulepszać. Zgodę możesz w każdej chwili zmienić w stopce
                    („Ustawienia cookies”). Szczegóły w{' '}
                    <Link href='/Polityka_prywatnosci_nekrodruk.pdf' target='_blank' rel='noopener noreferrer'>
                        polityce prywatności
                    </Link>
                    .
                </Typography>
                <Stack direction='row' spacing={1.5} className='cookieBanner_actions'>
                    <Button variant='outlined' onClick={handleReject}>
                        Tylko niezbędne
                    </Button>
                    <Button variant='contained' onClick={handleAccept}>
                        Akceptuję
                    </Button>
                </Stack>
            </Stack>
        </Paper>
    );
}
